import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function NotFound() {
  useEffect(() => { document.title = `Page not found | ${siteConfig.brandName}`; }, []);

  return (
    <main className="policy-page">
      <header className="policy-hero policy-hero--sand">
        <nav aria-label="Breadcrumb"><Link to="/">Home</Link><span>/</span><span>404</span></nav>
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p>The page may have moved or the address may be incomplete. Return home or continue to the complete collection.</p>
        <p><Link to="/">Return home</Link> · <Link to="/shop">Shop all products</Link></p>
      </header>
    </main>
  );
}

export default NotFound;
